const RecipeIngredients = () => {

	const domEl = document.querySelector('#main-recipe-ingredients');

	if(!domEl) {
		return;
	}

	const heroEl = document.querySelector('.acf-block-hero') ? document.querySelector('.acf-block-hero') : document.querySelector('.wp-block-cover');
	const heroOffsetHeight = heroEl ? heroEl.offsetHeight : 100;

	//const headerEl = document.querySelector('#the-header');
	const footerEl = document.querySelector('#the-footer');


	const handleScroll = () => {
		const maxY = document.body.scrollHeight - window.innerHeight;
		const currentScrollY = Math.min(maxY, window.scrollY);

		if(currentScrollY >= heroOffsetHeight/* && currentScrollY > footerEl.offsetHeight*/) {
			domEl.classList.add('js-fixed-in-view');
			const top = Math.round(Math.min(0, footerEl.getBoundingClientRect().y - window.innerHeight));
			domEl.style.transform = `translate3d(0, ${top}px, 0)`;
			//const top = Math.round(Math.min(headerEl.offsetHeight, footerEl.getBoundingClientRect().y - window.innerHeight));
			//domEl.style.marginTop = `${top}px`;
		}
		else {
			domEl.classList.remove('js-fixed-in-view');
			domEl.style.transform = `translate3d(0,0,0)`;
			//domEl.style.marginTop = `${headerEl.offsetHeight}px`;
		}
	}

	window.addEventListener('scroll', handleScroll);
	handleScroll();
};

export default RecipeIngredients;